(() => {
  if (window.spoiltMobileResultsReady) return;
  window.spoiltMobileResultsReady = true;
  const key = 'spoilt-mobile-columns';
  let columns = '2';
  try { if (localStorage.getItem(key) === '3') columns = '3'; } catch {}

  /* Desktop sort box: width follows the chosen option's text. Browsers that support CSS
     field-sizing do this on their own; for the rest we measure the text and set the width. */
  const desktop = window.matchMedia('(min-width: 990px)');
  const nativeFit = !!(window.CSS && CSS.supports && CSS.supports('field-sizing', 'content'));
  const fitSort = () => {
    document.querySelectorAll('.spoilt-grid-view-page .facet-filters__sort').forEach(select => {
      if (nativeFit || !desktop.matches) { select.style.removeProperty('width'); return; }
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const style = getComputedStyle(select);
      const probe = document.createElement('span');
      probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;';
      probe.style.fontFamily = style.fontFamily;
      probe.style.fontSize = style.fontSize;
      probe.style.fontWeight = style.fontWeight;
      probe.style.letterSpacing = style.letterSpacing;
      probe.textContent = option.textContent.trim();
      document.body.appendChild(probe);
      const textWidth = probe.getBoundingClientRect().width;
      probe.remove();
      select.style.width = Math.ceil(textWidth + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)) + 'px';
    });
  };

  /* Filter drawer, brands section.
     1) The theme's drawer script closes every <details> when the drawer closes. The brands section
        has no header to tap (like the desktop sidebar), so it must always stay open.
     2) Add the arrow box + model links to each brand bar (markup comes from the <template> tags that
        snippets/spoilt-facet-search.liquid prints). Runs again after every filter update. */
  const BRANDS = '#FacetFiltersFormMobile .mobile-facets__details[data-facet-param="filter.p.vendor"]';
  const keepBrandsOpen = () => {
    document.querySelectorAll(BRANDS).forEach(details => { if (!details.open) details.open = true; });
  };
  const addBrandModels = () => {
    document.querySelectorAll(BRANDS).forEach(details => {
      const models = new Map();
      details.querySelectorAll('template[data-spoilt-brand-models]').forEach(template => {
        models.set(template.getAttribute('data-spoilt-brand-models'), template);
      });
      if (!models.size) return;
      details.querySelectorAll('.mobile-facets__list > li').forEach(item => {
        if (item.querySelector('.spoilt-menu-collections__brand-details')) return;
        const input = item.querySelector('input[type="checkbox"]');
        const template = input && models.get(input.value);
        if (template) item.append(template.content.cloneNode(true));
      });
    });
  };
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (details && details.matches && details.matches(BRANDS) && !details.open) details.open = true;
  }, true);

  const sync = () => {
    document.querySelectorAll('.spoilt-mobile-results').forEach(root => {
      if (root.dataset.mobileColumns !== columns) root.dataset.mobileColumns = columns;
      root.querySelectorAll('[data-spoilt-mobile-columns]').forEach(button => {
        const pressed = String(button.dataset.spoiltMobileColumns === columns);
        if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      });
    });
    fitSort();
    keepBrandsOpen();
    addBrandModels();
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-spoilt-mobile-columns]');
    if (!button || !button.closest('.spoilt-mobile-results')) return;
    columns = button.dataset.spoiltMobileColumns === '3' ? '3' : '2';
    try { localStorage.setItem(key, columns); } catch {}
    sync();
  });
  document.addEventListener('change', event => {
    if (event.target.matches && event.target.matches('.facet-filters__sort')) fitSort();
  });
  if (desktop.addEventListener) desktop.addEventListener('change', fitSort);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSort);
  const start = () => {
    sync();
    document.querySelectorAll('.spoilt-mobile-results').forEach(root => {
      new MutationObserver(sync).observe(root, { childList: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();